export enum FolderInstanceTargetType {
	Original = 1,
	Link = 2
}